'use client'

import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { SiteNav } from '../../SiteNav'

// Audience-aware nav:
//  - landing (tenant root) → minimal (brand + powered, no links)
//  - /renters/* → renter links
//  - everything else (owner pages) → owner links
export function OwnerNav({ brand }: { brand: React.ReactNode }) {
  const path = usePathname() || ''
  const isLanding = path === '/' || /^\/owners\/[^/]+\/?$/.test(path)
  const isRenter = path.includes('/renters')

  if (isLanding) {
    return (
      <nav className="nav">
        <div className="nav-inner">
          <Link href="/" className="nav-brand" style={{ textDecoration: 'none' }}>
            {brand}
          </Link>
          <span className="powered" style={{ marginLeft: 'auto' }}>
            Powered by <strong>B.C. Strata Tech</strong>
          </span>
        </div>
      </nav>
    )
  }

  const HomeIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 11.5 12 4l9 7.5" />
      <path d="M5 10v10h14V10" />
    </svg>
  )
  const PlanIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="1.5" />
      <path d="M3 10h7M10 3v18M10 14h11" />
    </svg>
  )
  const yourStrata = {
    label: 'Your Strata',
    tourId: 'strata',
    children: [
      {
        href: '/your-home',
        label: 'Your Home',
        desc: 'Contacts, bylaws, key dates',
        icon: HomeIcon,
      },
      {
        href: '/community',
        label: 'Floorplans & Community',
        desc: 'Plans, gallery, the team',
        icon: PlanIcon,
      },
    ],
  }
  const links = isRenter
    ? [
        { href: '/renters', label: 'Home', tourId: 'home' },
        { href: '/renters/start', label: 'Checklist', tourId: 'checklist' },
        { href: '/renters/resources', label: 'Resources', tourId: 'resources' },
        yourStrata,
        { href: '/owner', label: 'Owner?', cta: true },
      ]
    : [
        { href: '/owner', label: 'Home', tourId: 'home' },
        { href: '/start', label: 'Checklist', tourId: 'checklist' },
        { href: '/resources', label: 'Resources', tourId: 'resources' },
        yourStrata,
        { href: '/renters', label: 'Renting?', cta: true },
      ]
  return <SiteNav brand={brand} brandHref={isRenter ? '/renters' : '/owner'} links={links} powered />
}
